const navMenuTitles = {
  Home: 'Inicio',
  AT: 'Asistencia Tecnológica',
  Inventory: 'Inventario',
};

export default navMenuTitles;
